import { baseUrl } from "@/config/env";
import request from "@/router/axios";
import { parseParam } from "@/util/util";
//查询提货单列表
export const findmaterialOrder = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/delivery_order/statisticalMaterialsHangCeiling?` + params,
    method: "GET",
  });
};
//修改提货单
export const updatematerialOrder = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/delivery_order`,
    method: "PUT",
    data: data,
  });
};
//删除提货单
export const delmaterialOrder = (ids) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/delivery_order/${ids}`,
    method: "DELETE",
  });
};
export const getmaterialOrder = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/delivery_order/materialRetrievalDetailsHangCeiling?` + params,
    method: "GET",
  });
};
export const findServiceRecordListOther = (data) => {
  return request({
    url:
      `${baseUrl}/joins-work/v1/workOrder/findServiceRecordListOther/` +
      data.id +
      `?clientType=` +
      data.clientType,
    method: "GET",
  });
};
export const downloadExcelmaterialOrder = (params) => {
  params = parseParam(params);
  return request({
    url:
      `${baseUrl}/joins-sales-cloud/v1/delivery_order/downloadExcelStatisticalMaterialsHangCeiling?` +
      params,
    method: "GET",
    responseType: "blob",
  });
};
export const downloadExcelMaterialRetrievalDetails = (params) => {
  params = parseParam(params);
  return request({
    url:
      `${baseUrl}/joins-sales-cloud/v1/delivery_order/downloadExcelMaterialRetrievalDetailsHangCeiling?` +
      params,
    method: "GET",
    responseType: "blob",
  });
};
//新增提货单
export const addmaterialOrder = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/delivery_order`,
    method: "POST",
    data: data,
  });
};
